import { render, staticRenderFns } from "./TbFilaAndamento.vue?vue&type=template&id=af0c2216&scoped=true"
import script from "./TbFilaAndamento.vue?vue&type=script&lang=js"
export * from "./TbFilaAndamento.vue?vue&type=script&lang=js"
import style0 from "./TbFilaAndamento.vue?vue&type=style&index=0&id=af0c2216&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af0c2216",
  null
  
)

export default component.exports